module.exports = __webpack_public_path__ + "static/media/driver-behaviour.8289c6d8.svg";